import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const yellowBooksApi = createApi({
  reducerPath: 'yellowBooksApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getYellowBooks: builder.query({
      query: () => {
        return {
          url: urls.yellowBooks,
        };
      },
    }),
    getYellowBook: builder.query({
      query: (id) => ({
        url: urls.yellowBookDetail(id),
      }),
    }),
    saveYellowBook: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.yellowBookDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.yellowBooks,
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
    deleteYellowBook: builder.mutation({
      query(id) {
        return {
          url: urls.yellowBookDetail(id),
          method: 'DELETE',
        };
      },
    }),
    archiveYellowBook: builder.mutation({
      query({ id, title, archive }) {
        return {
          url: urls.yellowBookDetail(id),
          method: 'PUT',
          data: { title, archived_at: archive + '' },
        };
      },
    }),
    generateYellowBookPdf: builder.mutation({
      query(id) {
        return {
          url: urls.yellowBookPdf(id, 'true'),
          method: 'GET',
        };
      },
    }),
    getSections: builder.query({
      query: (yellowBookId) => {
        return {
          url: urls.yellowBookSections(yellowBookId),
        };
      },
    }),
    getSection: builder.query({
      query: ({ yellowBookId, sectionId }) => {
        return {
          url: urls.yellowBookSectionDetail(yellowBookId, sectionId),
        };
      },
    }),
    saveSection: builder.mutation({
      query(req) {
        if (req.body.is_numbering) {
          const align = `{a${req.body.numbering_align[0]}}`;
          const prefix = `{o${req.body.numbering_prefix}}`;
          req.body.numbering_format_sk = req.body.numbering_format_readable
            .replace('{i}', prefix)
            .concat(align);
        }
        if (req.body.item_type === 'data') {
          req.body.content_sk = `${req.body?.content_before || ''}\n--DELI--\n${req.body?.content_after || ''}`;
          req.body.data_item_params = JSON.stringify(req.body.data_item_params);
        }

        if (req.sectionId) {
          return {
            url: urls.yellowBookSectionDetail(req.yellowBookId, req.sectionId),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.yellowBookSections(req.yellowBookId),
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
    deleteSection: builder.mutation({
      query(req) {
        return {
          url: urls.yellowBookSectionDetail(req.yellowBookId, req.sectionId),
          method: 'DELETE',
        };
      },
    }),
    getSectionTree: builder.query({
      query: (yellowBookId) => ({
        url: urls.yellowBookSectionsTree(yellowBookId),
      }),
    }),
    saveSectionsTree: builder.mutation({
      query(req) {
        return {
          url: urls.yellowBookSectionsTree(req.yellowBookId),
          method: 'PUT',
          data: req.data,
        };
      },
    }),
    getDataItems: builder.query({
      query: () => ({
        url: urls.yellowBookDataItems,
      }),
    }),
  }),
});

export const {
  useGetYellowBooksQuery,
  useGetYellowBookQuery,
  useSaveYellowBookMutation,
  useDeleteYellowBookMutation,
  useGenerateYellowBookPdfMutation,
  useArchiveYellowBookMutation,
  useGetSectionsQuery,
  useGetSectionQuery,
  useSaveSectionMutation,
  useSaveSectionsTreeMutation,
  useDeleteSectionMutation,
  useGetSectionTreeQuery,
  useGetDataItemsQuery,
} = yellowBooksApi;
